import { Auth } from "aws-amplify";
import { Hub } from "aws-amplify";

export class AuthService {
  isLoggedIn: boolean = false;
  failed: boolean = false;
  given_name: string = "";
  ldap: string = "";
  userId: string = "";

  constructor() {
    console.log("Listening...");
    //listens to any sign-in events
    Hub.listen("auth", ({ payload: { event, data } }) => {
      switch (event) {
        case "signIn":
          this.loginProcess();
          break;
        case "signIn_failure":
          this.isLoggedIn = false;
          break;
        default:
          break;
      }
    });
  }

  // Store the intended destination before redirecting to auth
  private storeIntendedDestination() {
    const currentPath =
      window.location.pathname + window.location.search + window.location.hash;
    if (currentPath !== "/" && currentPath !== "") {
      localStorage.setItem("intendedDestination", currentPath);
    }
  }

  // Retrieve and navigate to the intended destination after auth
  private navigateToIntendedDestination() {
    const intendedDestination = localStorage.getItem("intendedDestination");
    if (intendedDestination) {
      localStorage.removeItem("intendedDestination");
      // Use history.pushState instead of window.location.href for better React Router compatibility
      window.history.pushState(null, "", intendedDestination);
      // Dispatch a popstate event to notify React Router of the navigation
      window.dispatchEvent(new PopStateEvent("popstate"));
    }
  }

  //Authenticates user if current session does not exist
  async authenticate() {
    try {
      console.log("getting current session");
      await Auth.currentSession().then((session) => {
        this.given_name = session.getIdToken().decodePayload().given_name;
        this.userId = session.getIdToken().decodePayload()["identities"][0][
          "userId"
        ];
        this.ldap = session.getIdToken().decodePayload()["custom:ldap"];
        this.isLoggedIn = true;
      });

      // If we just authenticated and have an intended destination, navigate to it
      this.navigateToIntendedDestination();
    } catch (err) {
      if (!window.location.href.includes("code=")) {
        // Store the current path before redirecting to auth
        this.storeIntendedDestination();
        await Auth.federatedSignIn({ customProvider: "FederateOIDC" });
      }
    }
  }

  //get tokens
  async getToken(): Promise<string> {
    return (await Auth.currentSession()).getIdToken().getJwtToken();
  }

  //get logged in boolean
  getIsLoggedIn(): boolean {
    return this.isLoggedIn;
  }

  // Sets isLoggedIn to be true if current session exists, i.e., authenticated
  async loginProcess() {
    await Auth.currentSession().then((session) => {
      this.isLoggedIn = true;
      // Check if we need to navigate to intended destination after login
      this.navigateToIntendedDestination();
    });
  }
}

export default AuthService;
